import React from 'react';
import { connect } from 'react-redux';
import { CurrentUser } from '../shared/model/CurrentUser';
import { AdminDashboard } from './dashboards/AdminDashboard';
import { SuperAdminDashboard } from './dashboards/SuperAdminDashboard';
import { MyOutsourcesManagerDashboard } from './dashboards/MyOutsourcesManagerDashboard';
import { MyOutsourcesViewerDashboard } from './dashboards/MyOutsourcesViewerDashboard';
import { MyContractorsManagerDashboard } from './dashboards/MyContractorsManagerDashboard';
import { BreadcrumbsManagerInstance } from '../shared/breadcrumbs/BreadcrumbsManager';

class Dashboard extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;
        const { currentUser, outsource } = this.props;

        if ( currentUser.isSuperAdmin() ) {
            return <SuperAdminDashboard breadcrumbs={breadcrumbs}/>;
        }

        if ( currentUser.isAdmin() ) {
            return (
                <AdminDashboard
                    currentUser={currentUser}
                    outsource={outsource}
                    breadcrumbs={breadcrumbs}
                />
            );
        }

        if ( currentUser.isOutsourcesManager() ) {
            return <MyOutsourcesManagerDashboard breadcrumbs={breadcrumbs}/>;
        }

        if ( currentUser.isOutsourcesViewer() ) {
            return <MyOutsourcesViewerDashboard breadcrumbs={breadcrumbs}/>;
        }

        if ( currentUser.isContractorsManager() ) {
            return <MyContractorsManagerDashboard breadcrumbs={breadcrumbs}/>;
        }

        return null;
    }
}

const mapStateToProps = (state) => {
    const currentUser = CurrentUser.fromReduxState(state);
    const outsource = currentUser.hasCompany() ? state.outsources.outsources[currentUser.company().id] : null;
    return { outsource, currentUser };
};

export const DashboardScreen = connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/dashboard/DashboardScreen.jsx